<template>
  <ul>
    <li>
      <a href="https://proxyscrape.com/blog/linkedin-scraping/"
        >What is LinkedIn Scraping? Challenges and 4 Use Cases</a
      >
    </li>
    <li>
      <a href="https://proxyscrape.com/blog/tcp-proxy/"
        >TCP Proxy As A Reverse Proxy and A Load Balancer</a
      >
    </li>
    <li>
      <a href="https://proxyscrape.com/blog/web-scraping-vs-api-key-differences/"
        ><strong>Web Scraping vs. API – 7 Key Differences</strong></a
      >
    </li>
    <li>
      <a href="https://proxyscrape.com/blog/why-are-proxies-for-cyber-security-so-famous/"
        >Why are Proxies For Cyber Security so Famous – 2022</a
      >
    </li>
    <li>
      <a href="https://proxyscrape.com/blog/mac-proxy-settings/"
        >MAC Proxy Settings – A Setup Guide in 2022</a
      >
    </li>
  </ul>
</template>

<style scoped>
ul {
  margin: 0;
  padding: 0;
}
li {
  padding: 15px 0;
  list-style: none;
}
li:not(:last-child) {
  border-bottom: 1px solid #585f7126;
}
a {
  font-size: 14px;
  color: #3e445b;
  text-decoration: none;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  margin-bottom: 0;
  text-transform: uppercase;
  font-weight: 500;
}
a:hover {
  color: #3464e0;
}
</style>
